module.exports = __webpack_public_path__ + "img/14.450de397.jpg";